import { Heading } from "../Heading";
import CardFinanci from "./CardFinanci";
import * as Styled from "./styled";

type FinancialSummaryProps = {
  faturamentoBruto: string;
  despesas: string;
  lucroLiquido: string;
  totalPecasCompra: string;
}

const FinancialSummary = ({faturamentoBruto, despesas, lucroLiquido, totalPecasCompra}: FinancialSummaryProps) => {
  return (
    <Styled.Container>
      <Heading size="xmedium" as="h2" colorDark={false}>Resumo Financeiro</Heading>

      <Styled.Content>
        <CardFinanci text="Faturamento Bruto" value={faturamentoBruto} />
        <CardFinanci text="Mão de Obra" value={despesas} variant="negative" />
        <CardFinanci text="Valor das Peças" value={totalPecasCompra} variant="negative" />
        <CardFinanci text="Lucro Líquido" value={lucroLiquido} variant="positive" />
      </Styled.Content>
      
    </Styled.Container>
  );
};

export default FinancialSummary